<template>
  <div
    :class="{
      'bto-sb-widget bto-sb-widget-prematch-us bto-sb-widget-markets-us bto-sb-widget-markets-betbuilder-us':
        isUsLayout,
      'bto-sb-event-mormarket-market': !isUsLayout,
    }">
    <div
      class="bto-sb-event-mormarket-market-name"
      :class="{
        'bto-sb-event-market-cashout': false,
        'bto-sb-widget-title bto-sb-collapsed': isUsLayout,
        'bto-sb-event-mormarket-market-name': !isUsLayout,
        'bto-sb-show': isUsLayout && showMarket,
      }"
      @click="toggleMarket()">
      <!-- <i class="bto-app-cash" v-if="false"></i> -->
      <component :is="isUsLayout ? 'h3' : 'empty-component'">
        {{ market.label }}
      </component>
    </div>
    <component
      :is="isUsLayout ? 'div' : 'empty-component'"
      class="bto-sb-widget-content"
      v-if="showMarket">
      <div class="bto-sb-market-betbuildergroup">
        <BetBuilderItem
          v-for="(items, idx) in bbItems"
          :key="idx"
          @onItemSelect="onItemSelect"
          :showError="showError"
          :items="items"
          :selectedOutcomeId="bbSelections[idx]"
          :selectedGlobalId="activeMarket"
          :isComplexItem="isComplexItem"
          :itemLvl="idx"
          :class="{ 'bto-sb-builder-item-error': incompatibleMarket }" />
        <div v-if="isComplexItem" class="bto-sb-builder-item bto-sb-builder-itembtn">
          <button class="bto-sb-form-btn" @click="addToBetslip">
            {{ t("Mobile.add") }}
          </button>
        </div>
        <inline-message
          v-if="hasUnselectedItems && showError"
          :message="t('BB.ComplexMarketError')"
          type="error" />
        <!-- <inline-message
        v-if="incompatibleMarket"
        :message="t('BB.IncompatibleSelection')"
        type="error" /> -->
      </div>
    </component>
  </div>
</template>
<script>
  import BetBuilderItem from './betbuilder-item';
  import { EmptyComponent } from '@bto-widgets/utils/shared';
  import { toggleBetBuilder, betslipStore, getBetBuilderItemKey } from '@bto-services/betslip-core';
  import { checkLayout } from 'bto-models/app-settings/web';

  export default {
    name: 'BetBuilderMarket',
    components: { BetBuilderItem, EmptyComponent },
    props: {
      market: {
        type: Object,
        required: true,
      },
      fixture: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        bbItems: [],
        bbSelections: [],
        globalId: null,
        description: null,
        showError: false,
        incompatibleMarket: false,
        showMarket: true,
      };
    },
    computed: {
      isUsLayout() {
        return checkLayout('US');
      },
      isComplexItem() {
        // If we have nested items item is complex
        // eslint-disable-next-line
        if (!!(this.bbItems[0] && this.bbItems[0][0] && this.bbItems[0][0].Items)) {
          return true;
        }
        // If item has more than 3 selections count is as complex
        if (this.bbItems[0].length > 3) {
          return true;
        }
        return false;
      },
      hasUnselectedItems() {
        return this.bbSelections.length !== this.bbItems.length;
      },
      activeMarket() {
        if (this.isComplexItem) {
          return;
        }
        const itemKey = getBetBuilderItemKey(this.fixture);
        if (!betslipStore.items[itemKey]) {
          return;
        }
        const itemBetBuilderMarkets = betslipStore.items[itemKey].betBuilder || {}
        return this.bbItems[0].find(i => itemBetBuilderMarkets[i.GlobalIdLong]);
      },
    },
    created() {
      // push first item on market creation
      if (this.market && this.market.Filter && this.market.Filter.Items) {
        this.bbItems.push(this.market.Filter.Items);
      }
    },
    methods: {
      toggleMarket() {
        if (!this.isUsLayout) {
          return;
        }
        this.showMarket = !this.showMarket;
      },
      onItemSelect({ items, itemLvl, selection, globalId, description }) {
        this.showError = false;
        this.incompatibleMarket = false;
        this.bbItems = this.bbItems.slice(0, itemLvl + 1);
        this.bbSelections = this.bbSelections.slice(0, itemLvl);
        if (items && items.Items) {
          this.bbItems.push(items.Items);
        }
        if (selection) {
          this.bbSelections.push(selection);
        }

        this.globalId = this.bbSelections.length > 0 ? globalId : null;
        this.description = this.bbSelections.length > 0 ? description : null;
        // If we are simple market add it to betslip immediately
        if (!this.isComplexItem && globalId) {
          this.addToBetslip();
        }
      },
      resetSelections() {
        this.bbItems = [this.market.Filter.Items];
        this.bbSelections = [];
        this.globalId = null;
        this.description = null;
        this.showError = false;
        this.incompatibleMarket = false;
      },
      addToBetslip() {
        if (this.isComplexItem && this.hasUnselectedItems) {
          this.showError = true;
          return;
        }
        const bbMarket = {
          description: this.description,
          globalId: this.globalId,
          labelId: this.market.labelId,
          name: this.market.label,
          isComplex: this.isComplexItem,
        };

        toggleBetBuilder(this.fixture, bbMarket).then(val => {
          // If successfully added item in betslip reset selections
          if (val) {
            this.resetSelections();
            return;
          }
          // If simple item failed reset selection
          if (!this.isComplexItem) {
            this.resetSelections();
          }
          // If complex items failed mark them and keep selections
          if (this.isComplexItem) {
            this.incompatibleMarket = true;
          }
        });
      },
    },
  };
</script>
